export class HccModelVersion {
    ID: number; 
    ModelCategory: number;
    Version: string;
    StartDate: string;
    EndDate: string;
}
